import { Rule } from '@mui/icons-material';
import { guard } from '../RequirePermission';
import { ModelConfigList } from './ModelConfigList';
import { ModelConfigCreate } from './ModelConfigCreate';
import { ModelConfigEdit } from './ModelConfigEdit';

export { ModelConfigList } from './ModelConfigList';
export { ModelConfigCreate } from './ModelConfigCreate';
export { ModelConfigEdit } from './ModelConfigEdit';

// All three screens gated by the P2 management permission (REF-03 s.5). guard wraps each in
// <RequirePermission permission="ai_troubleshooting:manage:all">, which renders <AccessDeniedPage>
// if the actor lacks it (and honors *:*:* via hasPermission) — so even a hand-typed
// #/ai-model-configs URL is access-gated.
const PERM = 'ai_troubleshooting:manage:all';

export const aiModelConfigsResource = {
  list: guard(PERM, ModelConfigList),
  create: guard(PERM, ModelConfigCreate),
  edit: guard(PERM, ModelConfigEdit),
  icon: Rule,
  recordRepresentation: 'displayName',
  options: { label: 'AI Model Configs' },
};
